import { Component, Input } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
    selector: 'app-table-pages-showing',
    templateUrl: './table-pages-showing.component.html',
    styleUrls: ['./table-pages-showing.component.scss'],
    standalone: false
})
export class TablePagesShowingComponent {
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() list: any[];

  lang: 'en' | 'tr' | 'es';

  constructor(private storage: StorageService) {
    this.lang = this.storage.Get('lang');
  }
}
